import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';
import {PostToUser} from '../../api/services';
import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';
import moment from "moment";

class ComSaleBulk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ref: "",
            email: "",
            CurrentWallet: null,
            AgentWallet: [],
            Wallets: [],
            Agents: [],
            AgentsMap: {},
            Info: {},
            user: null,
            Role: "",
            Category: "airtime",
            RechargeNumber: "",
            RechargeAmount: "",

            bundleCategory: "",
            selectedBundle: null,
            bundleProduct:"",
            isLoading:false,
            myKeyboardUp:false,

            BundlesCategories:[],
            Bundles:[],
            DashboardWallet:[],
            newSale:{
                Ref:"",
                Category:"airtime",
                ProductType:"",
                ServicePackCode:"",
                RechargeNumber:"",
                SaleAmount:"0",
                Bundle:"",
                BundleCategory:"",
                totalData: 0,
                dataCsv: [],
                totalCost:0,
                status:"pending"
            },
            newUpload: {
                name: "",
                base64string: "",
                filename: "",
            },
        }

    }

    async componentDidMount() {

        await this.fetchWallet();
        await this.fetchBundlesCategory();
        await this.fetchBundlesLists();
        await this.fetchInfoAgent();
        await this.fetchInfoDealer();
        await this.fetchAgents();
    }
    async componentWillMount(){
        await this.isSupperUser();

    }
    handleInput=(e,key)=>{
        let tmp =this.state;
        tmp[key] = e.target.value;
        this.setState(tmp);
    }
    handleInputSale=(e,key)=>{
        let tmp =this.state;
        tmp.newSale[key] = e.target.value;
        this.setState(tmp);
    }
    isSupperUser = async () => {
        let user = GetUserToken();
        let tmp = this.state;
        tmp.user = user;
        tmp.email = user.Username;
        this.setState(tmp);
    }
    fetchBundlesLists=async ()=> {
        let _this = this;
        let conds = [];
        await this.fetchingAll("bundles", conds, (data) => {
            _this.setState({
                Bundles: data,
            });
        })
    }
    fetchBundlesCategory=async ()=> {
        let _this = this;
        let conds = [];
        await this.fetchingAll("bundlescategory", conds, (data) => {
            //console.log("bundlescategory > ",data);
            _this.setState({
                BundlesCategories: data,
            });
        })
    }
    fetchWallet=async ()=>{
        let _this = this;
        let conds = [];
        console.log("fetchWallet :> send ",_this.state);
        await this.fetchingAll("wallet", conds, (data) => {
            const phone  = GetUserToken().Phone;
            console.log("fetchWallet :> ", data,phone);
            let wallet = null;

            for(let i in data){
                const row = data[i];

                if(row.accountref ===phone){
                    console.log(":::-> [",row.accountref,"] == [",phone,"] ",(row.accountref ===phone)," >> ",row.amount);
                    wallet = {
                        Ref: row.accountref,
                        Amount:row.amount,
                        Type:row.accounttype
                    }
                }
            }

            if(wallet !==null){
                console.log(":::-> ",wallet)
            }

            _this.setState({
                Wallet: data,
                CurrentWallet:wallet,
            });

            this.props.dispatch({
                type:"ADD_WALLET_INFO",
                payload:wallet,
            })


        });
    }
    fetchingAll = async (table, conds, callback) => {
        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = "/backend-chela/api";
        let endpoint = backend+"/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToUser(hub, endpoint, function (dataIn, err) {
            //console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }
    fetchAgents = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("agent", conds, (data) => {
            console.log("fetchAgents :> ", data);
            let ls = [];
            let lsMap = {};
            for (let i in data) {
                const row = data[i];
                //console.log("+++++++++++>> ",row.dealer," == ",_this.state.ref);
                //if(row.dealer ===_this.state.ref){
                ls.push(row);
                lsMap[row.ref] = row;
                //}
            }
            _this.setState({
                Agents: ls,
                AgentsMap: lsMap
            });
        });
    }
    fetchInfoAgent = async () => {
        let _this = this;
        let endpoint = "/api/macro-finance/info/agent";
        const hub = {
            KeySearch: this.state.user.Username
        }
        let backend = eConfig.mainBackend;
        console.log("fetchInfoAgent send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchInfoAgent response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data.Dealer.Ref !== "") {
                    _this.setState({
                        Info: data,
                        ref: data.Dealer.Ref,
                        Role: "agent"
                    })
                }
            }
        });
    }
    fetchInfoDealer = async () => {
        console.log("fetchInfoDealer state > ", this.state.user);
        let _this = this;
        let endpoint = "/api/macro-finance/info/dealer";
        const hub = {
            KeySearch: this.state.user.Username
        }
        let backend = eConfig.mainBackend;
        console.log("fetchInfoDealer send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchInfoDealer response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data.Dealer.Ref !== "") {
                    _this.setState({
                        Info: data,
                        ref: data.Dealer.Ref,
                        Role: "dealer"
                    })
                }

            }
        });
    }
    getYourCurrentWalletBalance = () => {
        console.log("getYourCurrentWalletBalance :::-> ",this.state.CurrentWallet);
        if (this.state.CurrentWallet === null) {
            return 0
        }

        return this.state.CurrentWallet.Amount;
    }
    getAccountDealerRef=()=>{
        //todo
        let dealerRef="";
        if(typeof this.state.Info !=="undefined"){
            if(typeof this.state.Info.CommissionStructure !=="undefined"){
                if(typeof this.state.Info.CommissionStructure.DealerRef !=="undefined"){
                    dealerRef=this.state.Info.CommissionStructure.DealerRef;
                }
            }
        }
        return dealerRef;
    }
    handleInputFile = (e, id) => {
        let inputUpload = document.getElementById(id);
        let myfile = inputUpload.files[0];
        if (!myfile) {
            console.log("No file selected.");
            return;
        }
        let _this = this;
        let reader = new FileReader();
        reader.readAsDataURL(myfile);
        reader.onload = function () {
            let tmp = _this.state;
            tmp.newUpload.filename = myfile.name;
            tmp.newUpload.base64string = reader.result;
            _this.setState(tmp);
            _this.convertBase64CsvIntoString();
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    convertBase64CsvIntoString = async () => {
        let data = this.state.newUpload.base64string;
        const arr =data.split(";base64,");
        data =arr[1];
        //data = data.replace("data:text/csv;base64,", "");

        let _this = this;
        let hub = {};
        hub.Base64String = data;


        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/csv/json";

        console.log("convertBase64CsvIntoString send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("convertBase64CsvIntoString response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const arrDataString =  dataIn.RESULT;
                let header = {};
                let arrHeader = [];
                let arrDataJson = [];
                let ColCategory = {};
                let tot = 0;
                if (arrDataString.length > 0) {
                    const row1 = arrDataString[0];


                    for (let x in arrDataString) {

                            const row = arrDataString[x];
                            arrDataJson.push(row);
                            tot++;
                    }

                    //todo let create data row
                }

                //todo let calculate total cost
                let totalCost=0;
                let saleAmount=0;
                if(_this.state.newSale.Category==="airtime" && _this.state.newSale.SaleAmount !=="0"){
                    const amount =parseFloat(_this.state.newSale.SaleAmount);
                    const counter = parseFloat(tot);
                    totalCost  =counter *  amount;
                    saleAmount =amount;
                }

                if(_this.state.newSale.Category==="data" && _this.state.newSale.Bundle !==""){
                    // const item = row.productid + "--" + row.servicepackcode + "--" + row.servicepackdescription + "--" + row.amount + "--" + row.amountcode + "--" + row.category;
                    //
                    const arr = _this.state.newSale.Bundle.split("--");
                    let strAmount = arr[3].replace("R","");
                    const amount =parseFloat(strAmount);
                    const counter = parseFloat(tot);
                    totalCost  =counter *  amount;
                    saleAmount =amount;
                }

                let newSale = _this.state.newSale;
                newSale.totalCost = totalCost;
                newSale.totalData = tot;
                newSale.dataCsv = arrDataJson;
                newSale.SaleAmount = saleAmount;
                _this.setState({
                    newSale: newSale,
                })

            }
        });


    }
    submitSaleData=async (e)=>{
        e.preventDefault();
        const _this = this;
        const state  = this.state;
        const phone  = GetUserToken().Phone;
        const username  = GetUserToken.Username;
        let saleCost =state.newSale.totalCost;

        if(parseFloat(this.getYourCurrentWalletBalance()) <  parseFloat(saleCost) ){
            alert("Sorry your balance is low! please recharge");
            return
        }

        if(!window.confirm("Are you sure that you want to submit this sale? \n TotalNumber: "+state.newSale.totalData+"" +
            "\nTotal Cost:"+saleCost)){
            return
        }

        let accountType="agent";

        if(this.state.Info.Dealer.Id !==""){
            accountType="dealer"
        }

        const arr = this.state.newSale.Bundle.split("--");
        let phones=[];
        let saleAmount=0;
        if(this.state.newSale.Category==="data"){
            saleAmount =  parseFloat(arr[4])
        }else{
            saleAmount =  parseFloat(this.state.newSale.SaleAmount)
        }

        let hub = {
            BulkRef:this.state.newSale.Ref,
            Vendor:"0871112223",
            Agent: phone,
            Username:username,
            AccountType:accountType,
            Dealer: this.getAccountDealerRef(),
            RechargeNumber:"",
            SaleAmount:saleAmount,
        }
        hub.ProductType = this.state.newSale.Category;
        hub.ServicePackCode =arr[1];// "S2318";
        hub.Base64String = this.state.newUpload.base64string;

        console.log("submitSaleData > ",this.state.newSale," > ",hub)

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/sale/pinless/new-bulk";

        console.log("convertBase64CsvIntoString send > ", hub);
        await PostToBackend(hub, backend, endpoint, async function  (dataIn, err) {
            console.log("convertBase64CsvIntoString response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                alert("Thank you  for your bulk recharge, an email will be send to you once recharge done!")
                let tmp=_this.state;
                tmp.newSale={
                    Ref:"",
                        Category:"airtime",
                        ProductType:"",
                        ServicePackCode:"",
                        RechargeNumber:"",
                        SaleAmount:"0",
                        Bundle:"",
                        BundleCategory:"",
                        totalData: 0,
                        dataCsv: [],
                        totalCost:0,
                        status:"pending"
                };
                tmp.newUpload= {
                    name: "",
                        base64string: "",
                        filename: "",
                };
                _this.setState(tmp);
                await _this.fetchWallet()
                window.location.reload();

            }else{
                alert(":) Sorry error occurred during processing please try again")
            }
        })



    }

    renderSaleSummary=()=>{
        let state=this.state.newSale;
        return(
            <div className="row container">
                <div className="col-xs-12">
                    <h2 style={{textAlign:"right"}}>
                    <small >
                        <span style={{color:"red"}}>Summary</span> &nbsp;&nbsp;
                        <span style={{color:"gray"}}>Total Phone: {state.totalData}</span> &nbsp;&nbsp;
                        <span style={{color:"gray"}}>Total Cost: {state.totalCost}</span> &nbsp;&nbsp;
                        <span style={{color:"gray"}}>Category: {state.Category}</span> &nbsp;&nbsp;
                        <span style={{color:"gray"}}>Sale Amount: {state.SaleAmount}</span> &nbsp;&nbsp;
                    </small>
                    </h2>
                </div>

            </div>
        )
    }

    render(){
        const user =GetUserToken();
        return(
            <PageContentWallpaper {...this.props} >


                <div>
                    <div className="row container">
                        <div className="col-xs-12">
                            <h2>
                                Your Current Wallet
                                <span className={"pull-right"}>
                                        Balance:&nbsp;&nbsp;
                                    <b style={{
                                        color: "red",
                                        fontSize: 24
                                    }}>{"R " + this.getYourCurrentWalletBalance()}</b>
                                    </span>
                            </h2>
                        </div>
                        
                    </div>
                </div>

                <form onSubmit={this.submitSaleData}>
                <div className="row">
                    <div className="col-xs-12">

                        <div className="form-group">
                            <label>Bulk Reference</label>
                            <input
                                type="text"
                                className="form-control"
                                required={true}
                                onChange={(e) => this.handleInputSale(e, "Ref")}
                            />
                        </div>


                        <div className="form-group">
                            <label>Choose Category</label>
                            <select
                                className="form-control"
                                required={true}
                                onChange={(e)=>this.handleInputSale(e,"Category")}
                                value={this.state.newSale.Category}
                            >
                                <option value={"airtime"}>Airtime</option>
                                <option value={"data"}>Data</option>
                            </select>
                        </div>

                        {this.state.newSale.Category === "data" ?
                            <div>
                                <div className="form-group">
                                    <label>Choose Bundle Category</label>
                                    <select
                                        className="form-control"
                                        required={true}
                                        onChange={(e) => this.handleInputSale(e, "BundleCategory")}
                                        value={this.state.newSale.BundleCategory}
                                    >
                                        <option value={""}>--Select Bundle Category--</option>
                                        {this.state.BundlesCategories.map((row) => {
                                            return (
                                                <option value={row.name}>{row.name}</option>
                                            )
                                        })}

                                    </select>
                                </div>


                                <div className="form-group">
                                    <label>Choose Bundles</label>
                                    <select
                                        className="form-control"
                                        required={true}
                                        onChange={(e) => this.handleInputSale(e, "Bundle")}
                                        value={this.state.newSale.Bundle}
                                    >
                                        <option value={""}>--Select Bundle--</option>
                                        {this.state.Bundles.map((row) => {
                                            console.log("&&&&-> ", row);
                                            if (row.category !== this.state.newSale.BundleCategory) {
                                                return null
                                            }
                                            const item = row.productid + "--" + row.servicepackcode + "--" + row.servicepackdescription + "--" + row.amount + "--" + row.amountcode + "--" + row.category;
                                            const desc = row.amount + " - " + row.servicepackdescription;
                                            return (
                                                <option value={item}>{desc}</option>
                                            )
                                        })}

                                    </select>
                                </div>

                            </div> :
                            <div className="form-group">
                                <label>Sale Amount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    required={true}
                                    onChange={(e) => this.handleInputSale(e, "SaleAmount")}
                                />
                            </div>

                        }





                            <div className="form-group">
                                <label>Choose your file</label>
                                <input
                                    id={"myFile"}
                                    type="file"
                                    className="form-control"
                                    required={true}
                                    onChange={(e) => this.handleInputFile(e, "myFile")}
                                />
                            </div>

                        {this.renderSaleSummary()}

                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="btn-primary form-control"
                                >Submit
                                </button>
                            </div>


                    </div>

                </div>
                </form>





            </PageContentWallpaper>
        )
    }

}


const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ComSaleBulk)